'use strict';

define('lib/helpers/replace',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('replace', function (find, replace, options) {
    var string = options.fn(this);
    return string.replace(find, replace);
  });
});

